import { useState } from 'react'

import { BorderedRadioButton } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

import QuoteFlowButtonNav from '../QuoteFlowButtonNav'
import { CensusUpload } from './CensusUpload'
import { EmployeeEntry, type EmployeeInfo } from './employee_entry/EmployeeEntry'

type CreateCensusProps = {
  prospectId: string
  censusId?: string
  manualEntryEmployees?: EmployeeInfo[]
  previousStepPath: string
  onCensusProcessed: (censusId: string) => Promise<void>
}

export default function CreateCensus ({
  prospectId,
  censusId,
  manualEntryEmployees,
  previousStepPath,
  onCensusProcessed,
}: CreateCensusProps) {
  const { assign } = useWindowLocation()

  const [censusType, setCensusType] = useState<'csv' | 'manual'>(manualEntryEmployees ? 'manual' : 'csv')

  return (
    <div>
      <div className='grid grid-cols-2 gap-3'>
        <BorderedRadioButton
          value='csv'
          label='Upload CSV census'
          description='Upload a .CSV file of your employee census.'
          checked={censusType === 'csv'}
          onChange={() => setCensusType('csv')}
        />
        <BorderedRadioButton
          value='manual'
          label='Manual entry'
          description='Add employees one by one and manually input their information.'
          checked={censusType === 'manual'}
          onChange={() => setCensusType('manual')}
        />
      </div>
      <div className='my-10'>
        <div className={censusType === 'csv' ? 'block' : 'hidden'}>
          <CensusUpload
            prospectId={prospectId}
            onCensusProcessed={onCensusProcessed}
          />
        </div>
        <div className={censusType === 'manual' ? 'block' : 'hidden'}>
          <EmployeeEntry
            prospectId={prospectId}
            existingCensusId={censusId}
            existingEmployees={manualEntryEmployees}
            onEmployeesAdded={onCensusProcessed}
            renderNavButtons={({ onSubmit, isSubmitDisabled }) => (
              <QuoteFlowButtonNav
                onBack={() => {
                  assign(previousStepPath)
                }}
                onNext={onSubmit}
                isNextDisabled={isSubmitDisabled}
              />
            )}
          />
        </div>
      </div>
    </div>
  )
}
